AOS.init({
    duration: 800,
    offset: 90
});



// WEBPACK FOOTER //
// ./src/js/inc/aos-init.js